import Axios from "axios";
import {
  getLcImportGnrList,
  getLcImportGnrById as getLcImportGnrByIdApi,
  saveUpdateLcImportGnr,
  getReceivableLcImportGnrList,
} from "@/store/api";
import {
  SET_LC_IMPORT_GNR_LIST,
  UNSET_LC_IMPORT_GNR_LIST,
  SET_EDITING_LC_IMPORT_GNR,
  UNSET_EDITING_LC_IMPORT_GNR,
  SET_RECEIVABLE_LC_IMPORT_GNR_LIST,
  UNSET_RECEIVABLE_LC_IMPORT_GNR_LIST,
} from "@/store/mutation-types";

const state = {
  lcImportGnrList: [],
  editingLcImportGnr: null,
  getReceivableLcImportGnrList: [],
};

const getters = {
  getLcImportGnrList(state) {
    return state.lcImportGnrList;
  },
  getEditingLcImportGnr(state) {
    return state.editingLcImportGnr;
  },
  getReceivableLcImportGnrList(state){
    return state.getReceivableLcImportGnrList;
  }
  
};

const mutations = {
  [SET_LC_IMPORT_GNR_LIST](state, data) {
    state.lcImportGnrList = data;
  },
  [UNSET_LC_IMPORT_GNR_LIST](state) {
    state.lcImportGnrList = [];
  },
  [SET_EDITING_LC_IMPORT_GNR](state, data) {
    state.editingLcImportGnr = data;
  },
  [UNSET_EDITING_LC_IMPORT_GNR](state) {
    state.editingLcImportGnr = null;
  },
  [SET_RECEIVABLE_LC_IMPORT_GNR_LIST](state, data) {
    state.getReceivableLcImportGnrList = data;
  },
  [UNSET_RECEIVABLE_LC_IMPORT_GNR_LIST](state) {
    state.getReceivableLcImportGnrList = [];
  },
};

const actions = {
  saveUpdateLcImportGnr({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcImportGnr, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getLcImportGnrList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcImportGnrList)
        .then((response) => {
          if (response.data.success) {
            commit(SET_LC_IMPORT_GNR_LIST, response.data.data);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getReceivableLcImportGnrList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getReceivableLcImportGnrList)
        .then((response) => {
          if (response.data.success) {
            commit(SET_RECEIVABLE_LC_IMPORT_GNR_LIST, response.data.data);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getLcImportGnrById({ commit }, id) {
    const url = `${getLcImportGnrByIdApi}${id}`;
    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          if (response.data.success) {
            commit(SET_EDITING_LC_IMPORT_GNR, response.data.data);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



